export var container = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: '1em 0'
};
export var title = {
  paddingBottom: '1em'
};
export var qrWrapper = {
  margin: '1.5em 0'
};
export var secretCode = function secretCode(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75em',
    backgroundColor: theme.gray100,
    padding: '0.75em 1.5em',
    borderRadius: 6,
    fontFamily: 'monospace',
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: 2,
    marginBottom: '0.5em',
    userSelect: 'all'
  };
};
export var copiedText = function copiedText(theme) {
  return {
    color: theme.success,
    fontSize: 13,
    marginBottom: '1em'
  };
};
export var instructions = function instructions(theme) {
  return {
    color: theme.grayDark,
    fontSize: 14,
    lineHeight: 1.6,
    marginBottom: '0.5em'
  };
};
export var stepsList = function stepsList(theme) {
  return {
    color: theme.grayDark,
    fontSize: 14,
    lineHeight: 1.8,
    paddingLeft: '1.2em',
    marginBottom: '1.5em',
    textAlign: 'left'
  };
};